import { Field } from 'formik';
import PropTypes from 'prop-types';
import React from 'react';
import 'react-day-picker/lib/style.css';
import formatTimeString from '../../utils/formatTimeString';
import { packagePrice, packagePricePreTax } from '../../utils/packagePrice';
import { FormField } from '../common/FormField';
import { FormFieldWrapper } from '../common/FormFieldWrapper';
import PriceSum from '../common/PriceSum';
import SimpleDate from '../common/SimpleDate';
import SetHiddenFieldValue from './SetHiddenFieldValue';

export const AddOnGuestInfo = ({
  addOns,
  pkg,
  sale,
  salePkg,
  pkgAddOns,
  config,
  disabled,
  num,
  setFieldValue,
  sharedAddress,
  setSharedAddress,
  values
}) => {
  return (
    <div className="swformfield-tktpackage-lineitem">
      <div className="swformfield-tktpackage-lineitem__summary">
        <div className="swformfield-tktpackage-lineitem__summary-header">
          {pkg.descrip}
          {sale && salePkg && salePkg.time && (
            <span>
              &nbsp;@&nbsp;
              {formatTimeString(sale.day, salePkg.time)}
            </span>
          )}
          <span className="swformfield-tktpackage-lineitem__summary-header-quantity">
            &nbsp;({num})
          </span>
        </div>
        <div className="swformfield-swformfield-tktpackage-lineitem__amount-total">
          {config.taxInclusive ? (
            <PriceSum price={packagePrice(pkg, sale)} count={num} />
          ) : (
            <PriceSum price={packagePricePreTax(pkg, sale)} count={num} />
          )}
        </div>
      </div>

      {addOns != null && addOns.length > 0 && (
        <div className="swformfield-tktpackage-lineitem__addons-header">
          <div className="swformfield-tktpackage-lineitem__addons-header__header">
            Addons
          </div>
        </div>
      )}

      <div className="swformfield-tktpackage-lineitem__addons-list">
        {(addOns == null || addOns.length < 1) && (
          <div className="swformfield-tktpackage-lineitem__addon">
            <div className="swformfield-tktpackage-lineitem__addon--summary">
              No addons
            </div>
          </div>
        )}

        {addOns.map(addOn => {
          const pkgAddOnQuantity = pkgAddOns[addOn.item_id].qty || 0;

          return new Array(pkgAddOnQuantity).fill('placehoder').map((_, i) => {
            const isPassholder = config.isFirstGuestPassholder && i === 0;
            const needsAddress =
              isPassholder || (!isPassholder && !sharedAddress);
            const fieldStyles = needsAddress ? {} : { display: 'none' };

            return (
              <div
                className="swform"
                key={`${addOn.item_id}-${pkg.item_id}-${i}`}
              >
                <div className="swformsection">
                  <div className=" swformfield-tktpackage-lineitem__addon">
                    <div>
                      <label className="swformfield__label">
                        {addOn.descrip} GUEST {i + 1}
                        {isPassholder &&
                          ` (${config.passholderLabel.toUpperCase()})`}
                      </label>
                      <div className="swformfield-tktpackage-lineitem__addon--guest">
                        <FormField
                          label={`${
                            isPassholder ? `${config.passholderLabel} ` : ''
                          }First Name`}
                          type="text"
                          name={`${addOn.item_id}-${pkg.item_id}-${i}-first_name`}
                          disabled={disabled}
                          autoComplete="off"
                          maxLength="100"
                          required
                        />
                        <FormField
                          label={`${
                            isPassholder ? `${config.passholderLabel} ` : ''
                          }Last Name`}
                          type="text"
                          name={`${addOn.item_id}-${pkg.item_id}-${i}-last_name`}
                          disabled={disabled}
                          autoComplete="off"
                          maxLength="100"
                          required
                        />
                        <FormField
                          label={`${
                            isPassholder ? `${config.passholderLabel} ` : ''
                          }Email`}
                          type="email"
                          name={`${addOn.item_id}-${pkg.item_id}-${i}-email_init`}
                          disabled={disabled}
                          autoComplete="email"
                          maxLength="100"
                          required
                        />
                        <FormField
                          label={`Confirm ${
                            isPassholder ? `${config.passholderLabel} ` : ''
                          }Email`}
                          type="email"
                          name={`${addOn.item_id}-${pkg.item_id}-${i}-email_confirm`}
                          disabled={disabled}
                          maxLength="100"
                          required
                        />
                        <FormFieldWrapper
                          label={`${
                            isPassholder ? `${config.passholderLabel} ` : ''
                          }Birthday (MM/DD/YYYY)`}
                          type={'text'}
                          name={`${addOn.item_id}-${pkg.item_id}-${i}-birth_date`}
                          required
                        >
                          <SimpleDate
                            name={`${addOn.item_id}-${pkg.item_id}-${i}-birth_date`}
                            value={
                              values[
                                `${addOn.item_id}-${pkg.item_id}-${i}-birth_date`
                              ]
                            }
                            onChange={value => {
                              if (value) {
                                setFieldValue(
                                  `${addOn.item_id}-${pkg.item_id}-${i}-birth_date`,
                                  value
                                );
                              }
                            }}
                          />
                        </FormFieldWrapper>

                        {sharedAddress && i > 0 ? (
                          <SetHiddenFieldValue
                            setFieldValue={setFieldValue}
                            addOnItemId={addOn.item_id}
                            pkgItemId={pkg.item_id}
                            fieldToSet="address"
                            valueToSet={
                              values[
                                `${addOn.item_id}-${pkg.item_id}-0-address`
                              ]
                            }
                            pkgAddOnQuantity={pkgAddOnQuantity}
                          />
                        ) : (
                          <FormField
                            label={`${
                              isPassholder ? `${config.passholderLabel} ` : ''
                            }Address`}
                            type="text"
                            name={`${addOn.item_id}-${pkg.item_id}-${i}-address`}
                            disabled={disabled || !needsAddress}
                            autoComplete="street-address"
                            maxLength="100"
                            required={needsAddress}
                            style={fieldStyles}
                          />
                        )}
                        {sharedAddress && i > 0 ? (
                          <SetHiddenFieldValue
                            setFieldValue={setFieldValue}
                            addOnItemId={addOn.item_id}
                            pkgItemId={pkg.item_id}
                            fieldToSet="city"
                            valueToSet={
                              values[`${addOn.item_id}-${pkg.item_id}-0-city`]
                            }
                            pkgAddOnQuantity={pkgAddOnQuantity}
                          />
                        ) : (
                          <FormField
                            label={`${
                              isPassholder ? `${config.passholderLabel} ` : ''
                            }City`}
                            type="text"
                            name={`${addOn.item_id}-${pkg.item_id}-${i}-city`}
                            disabled={disabled || !needsAddress}
                            autoComplete="address-level2"
                            maxLength="100"
                            required={needsAddress}
                            style={fieldStyles}
                          />
                        )}
                        {sharedAddress && i > 0 ? (
                          <SetHiddenFieldValue
                            setFieldValue={setFieldValue}
                            addOnItemId={addOn.item_id}
                            pkgItemId={pkg.item_id}
                            fieldToSet="state"
                            valueToSet={
                              values[`${addOn.item_id}-${pkg.item_id}-0-state`]
                            }
                            pkgAddOnQuantity={pkgAddOnQuantity}
                          />
                        ) : (
                          <FormField
                            label={`${
                              isPassholder ? `${config.passholderLabel} ` : ''
                            }State`}
                            type="text"
                            name={`${addOn.item_id}-${pkg.item_id}-${i}-state`}
                            disabled={disabled || !needsAddress}
                            autoComplete="address-level1"
                            maxLength="100"
                            required={needsAddress}
                            style={fieldStyles}
                          />
                        )}
                        {sharedAddress && i > 0 ? (
                          <SetHiddenFieldValue
                            setFieldValue={setFieldValue}
                            addOnItemId={addOn.item_id}
                            pkgItemId={pkg.item_id}
                            fieldToSet="zip"
                            valueToSet={
                              values[`${addOn.item_id}-${pkg.item_id}-0-zip`]
                            }
                            pkgAddOnQuantity={pkgAddOnQuantity}
                          />
                        ) : (
                          <FormField
                            label={`${
                              isPassholder ? `${config.passholderLabel} ` : ''
                            }ZIP code`}
                            type="text"
                            name={`${addOn.item_id}-${pkg.item_id}-${i}-zip`}
                            disabled={disabled || !needsAddress}
                            autoComplete="postal-code"
                            maxLength="20"
                            required={needsAddress}
                            style={fieldStyles}
                          />
                        )}
                        {isPassholder && pkgAddOnQuantity > 1 && (
                          <>
                            <Field
                              className="swformfield__control"
                              type="checkbox"
                              id={`${addOn.item_id}-${pkg.item_id}-0-share-address`}
                              name={`${addOn.item_id}-${pkg.item_id}-0-share-address`}
                              disabled={disabled}
                              onChange={() =>
                                setSharedAddress(prevState => !prevState)
                              }
                            />
                            <label
                              htmlFor={`${addOn.item_id}-${pkg.item_id}-0-share-address`}
                              style={{
                                marginLeft: '0.5rem',
                                fontWeight: 'bold',
                                color: 'black',
                                cursor: 'pointer'
                              }}
                              className="swformfield__label"
                            >
                              Use this address for all passholders?
                            </label>
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            );
          });
        })}
      </div>
    </div>
  );
};

AddOnGuestInfo.propTypes = {
  pkg: PropTypes.object,
  num: PropTypes.number,
  disabled: PropTypes.bool,
  addOns: PropTypes.array,
  value: PropTypes.object,
  onChange: PropTypes.func,
  maxMet: PropTypes.bool,
  minMet: PropTypes.bool,
  salePkg: PropTypes.object,
  sale: PropTypes.object,
  config: PropTypes.object,
  pkgAddOns: PropTypes.object,
  setFieldValue: PropTypes.func,
  isPassholder: PropTypes.bool,
  sharedAddress: PropTypes.bool,
  setSharedAddress: PropTypes.func,
  values: PropTypes.shape({})
};
